export default 'M7,10L12,15L17,10H7Z';
